import moment from 'moment';
import { get as getProduitLocation } from '@/api/produit/produitLocation';
import { UNITE } from '@/configuration/devisConf';

export default async function genererLiaisonTarifFromProduitAssocieLoc(produitAssocieLocId) {
  const produitAssocieLoc = (await getProduitLocation(produitAssocieLocId)).data.result;
  let infoProduitAssocie = produitAssocieLoc.produitDivers;
  if (produitAssocieLoc.produitLocation) infoProduitAssocie = produitAssocieLoc.produitLocation;
  const liaison = {
    produitEnfantId: produitAssocieLoc.id,
    produitEnfant: produitAssocieLoc,
    libelle: produitAssocieLoc.libelle,
    liaisonsTarif: produitAssocieLoc.liaisonsTarif,
    uniteVente: infoProduitAssocie ? infoProduitAssocie.uniteVente : UNITE,
    quantite: infoProduitAssocie ? infoProduitAssocie.quantite : 0,
    prixUnitaire: infoProduitAssocie ? infoProduitAssocie.prixUnitaire : 0,
    dateDebut: moment().toDate(),
    dateFin: null,
    divers: false,
    location: true,
    archive: false,
    isAlreadySelect: true,
  };
  return liaison;
}
